import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import { iconSize } from '../../../utils/helpers.js';

/* eslint-disable max-len */

var AllLike = (function (_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'xs' : _a$size,
      props = __rest(_a, ["size"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: iconSize[size],
    height: iconSize[size],
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5625 4.99637L9.29671 10.6902V19.0025H16.3726C17.0614 19.0025 17.6617 18.5337 17.8288 17.8655L18.9543 13.3636C19.0664 12.9152 18.9656 12.4402 18.6812 12.0758C18.3967 11.7115 17.9603 11.4985 17.498 11.4985H14.498C13.9457 11.4985 13.498 11.0508 13.498 10.4985V7.1098C13.498 6.27681 12.982 5.53092 12.2026 5.23715L11.5625 4.99637ZM8.29869 21.0025C8.29803 21.0025 8.29737 21.0025 8.29671 21.0025C8.29606 21.0025 8.2954 21.0025 8.29474 21.0025H5.49428C4.11322 21.0025 2.99365 19.8829 2.99365 18.5019V11.9992C2.99365 10.6181 4.11322 9.49855 5.49428 9.49855L7.61839 9.49855L9.70428 4.25688C10.1075 3.24364 11.248 2.74005 12.2684 3.12464L12.9079 3.36565C14.4664 3.95301 15.498 5.44432 15.498 7.1098V9.49855H17.498C18.5761 9.49855 19.5941 9.99525 20.2576 10.845C20.9211 11.6948 21.156 12.8028 20.8946 13.8487L19.7691 18.3506C19.3794 19.9091 17.9791 21.0025 16.3726 21.0025H8.29869ZM7.29671 11.4985H5.49428C5.21779 11.4985 4.99365 11.7227 4.99365 11.9992V18.5019C4.99365 18.7784 5.21779 19.0025 5.49428 19.0025H7.29671V11.4985Z",
    fill: "currentColor"
  }));
});

export { AllLike as default };
